import { AxiosInstance, CancelToken } from 'axios';

import { GetUrlResponse } from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/shared-view';

export class SharedViewServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getAssetGeometryUrl(
    params: types.GetAssetGeometryUrlParameters,
  ): Promise<common.GetUrlResponse> {
    return (
      await this.axios.get(
        `/v1/shared-views/${params.path.sharedViewId}/assets/${params.path.dynamicAssetId}/geometry/url`,
        {
          params: params.query,
        },
      )
    ).data;
  }

  async getFileById(params: types.GetFileByIdParameters): Promise<common.FileModelResponse> {
    const { data } = await this.axios.get<common.FileModelResponse>(
      `/v1/shared-views/${params.path.sharedViewId}/files/${params.path.fileId}`,
    );
    return data;
  }

  async getFileVersionUrl(params: types.GetFileVersionUrlParameters): Promise<GetUrlResponse> {
    return (
      await this.axios.get<Promise<common.GetUrlResponse>>(
        `/v1/shared-views/${params.path.sharedViewId}/file-version/${params.path.fileVersionId}/url`,
        { params: params.query },
      )
    ).data;
  }

  async getComment(
    params: types.GetCommentParameters,
    cancelToken?: CancelToken,
  ): Promise<types.GetCommentResponse> {
    const { data } = await this.axios.get(
      `/v1/shared-views/${params.path.sharedViewId}/comments/${params.path.commentId}`,
      {
        params: new URLSearchParams([
          ...(params.query.include ?? []).map((x) => ['include', x]),
          ...(params.query.orderBy ?? []).map((x) => ['orderBy', x]),
        ]),
        cancelToken,
      },
    );

    return data;
  }
}
